/**
 * 管理端手动赠送试课 API（ADM-02 GRANT，manual-trial-grant）。
 *
 * 无报名单据的试课入账：提交必填中文原因 ≤255、次数 1~3；幂等键由弹窗
 * 挂载时生成、重试复用、成功后重置。409 业务拒绝（已购/归档/停售）经
 * Transport 抛 ApiError（code 形如 entitlement.manual_trial_grant_*），
 * 由弹窗按错误码映射中文提示。
 */
import { ApiPaths } from './api.config';
import { http } from './transport';

/** 手动赠送试课提交载荷（后端 CreateManualTrialGrantDto）。 */
export interface CreateManualTrialGrantPayload {
  studentId: string;
  skuId: string;
  /** 赠送次数 1~3 整数。 */
  quantity: number;
  /** 业务原因（trim 非空，≤255 字）。 */
  reason: string;
  /** 幂等键（UUID；同键重放返回 applied=false + 当前余额）。 */
  idempotencyKey: string;
}

/** 手动赠送试课结果（后端 CreateManualTrialGrantResultDto）。 */
export interface ManualTrialGrantResult {
  /** 是否实际入账（幂等重放命中为 false）。 */
  applied: boolean;
  /** 权益账户 ID。 */
  accountId: string;
  /** 赠后（或幂等重放时当前）赠送课池可用余额。 */
  giftedAvailableQuantity: number;
}

/** 赠课记录明细（后端 ManualTrialGrantDetailDto；操作人/学生/SKU 名称联查）。 */
export interface ManualTrialGrantDetail {
  id: string;
  quantity: number;
  reason: string;
  operatorId: string;
  /** 操作人姓名（员工已删则为 null）。 */
  operatorName: string | null;
  createdAt: string;
  studentId: string;
  studentName: string;
  skuId: string;
  skuName: string;
  /** 关联权益账户（写入时为空，派发成功后回填）。 */
  accountId: string | null;
}

async function createManualTrialGrant(
  payload: CreateManualTrialGrantPayload,
): Promise<ManualTrialGrantResult> {
  return http.post<ManualTrialGrantResult>(
    ApiPaths.manualTrialGrants.create,
    payload,
  );
}

async function getManualTrialGrantDetail(
  id: string,
): Promise<ManualTrialGrantDetail> {
  return http.get<ManualTrialGrantDetail>(ApiPaths.manualTrialGrants.detail(id));
}

/** 手动赠送试课 API 唯一对外入口。 */
export const manualTrialGrantApi = {
  createManualTrialGrant,
  getManualTrialGrantDetail,
};
